export default __webpack_public_path__ + "static/media/gs-7.5a9d247e.png";